import axios, { AxiosResponse } from 'axios'
import {
  ExameDtoCadastro,
  ExamesQueryResponse,
  FormulaDtoCadastro,
  FormulasQueryResponse,
  FormulaView,
  MedicamentoDtoCadastro,
  MedicamentoQueryResponse,
  MedicamentoView,
  OrientacaoView,
  OrientacoesQueryResponse,
  PrescricaoDtoApacQuantidade,
  PrescricaoDtoAssinatura,
  PrescricaoDtoAssinaturaLote,
  PrescricaoDtoAtestado,
  PrescricaoDtoDadosPaciente,
  PrescricaoDtoDocumento,
  PrescricaoDtoExame,
  PrescricaoDtoFormula,
  PrescricaoDtoLmeQuantidade,
  PrescricaoDtoMedicamento,
  PrescricaoDtoOrientacao,
  PrescricaoView,
  PrescricoesQueryResponse,
  TipoAtestadoQueryResponse,
  TipoAtestadoView,
} from './_model'
import { ArquivoDto } from '../../../atendimento/core/_models'
import { ModeloList } from 'app/modules/apps/admin/modelos/modelos-list/core/_models'
import { ExameView } from 'app/modules/apps/admin/exames/exames-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const PRESCRICAO_EXAME_URL = `${API_URL}/prescricao/exames`
const PRESCRICAO_FORMULA_URL = `${API_URL}/prescricao/formulas`
const PRESCRICAO_MEDICAMENTO_URL = `${API_URL}/prescricao/medicamentos`
const PRESCRICAO_ORIENTACAO_URL = `${API_URL}/prescricao/orientacao`
const PRESCRICAO_ORIENTACOES_URL = `${API_URL}/prescricao/orientacoes`
const PRESCRICAO_ATESTADO_URL = `${API_URL}/prescricao/atestado`
const PRESCRICAO_ATESTADOS_URL = `${API_URL}/prescricao/atestados`
const PRESCRICAO_DOCUMENTOS_URL = `${API_URL}/prescricao/documentos`
const PRESCRICAO_DOCUMENTO_URL = `${API_URL}/prescricao/documento`
const PRESCRICAO_LME_URL = `${API_URL}/prescricao/lme`
const PRESCRICAO_APAC_URL = `${API_URL}/prescricao/apac`

// PRESCRICAO

export const getPrescricoes = (query: string): Promise<PrescricoesQueryResponse> => {
  return axios
    .get(`${API_URL}/prescricao?${query}`)
    .then((resp: AxiosResponse<PrescricoesQueryResponse>) => resp.data)
}

export const getPrescricaoById = (prescricaoId: number): Promise<PrescricaoView> => {
  return axios
    .get(`${API_URL}/prescricao/${prescricaoId}`)
    .then((resp: AxiosResponse<PrescricaoView>) => resp.data)
}

export const deletePrescricao = (prescricaoId: number): Promise<void> => {
  return axios.delete(`${API_URL}/prescricao/${prescricaoId}`)
}

// EXAMES
export const getExames = (query: string): Promise<ExamesQueryResponse> => {
  return axios
    .get(`${PRESCRICAO_EXAME_URL}?${query}`)
    .then((resp: AxiosResponse<ExamesQueryResponse>) => resp.data)
}

export const getExameById = (exameId: number): Promise<ExameView> => {
  return axios
    .get(`${PRESCRICAO_EXAME_URL}/${exameId}`)
    .then((resp: AxiosResponse<ExameView>) => resp.data)
}

/**
 * Altera um exame
 * @param exameId Identificador do exame
 * @param exame ExameDtoCadastro
 * @returns ExameView
 */
export const updateExame = (exameId: number, exame: ExameDtoCadastro): Promise<ExameView> => {
  return axios
    .put(`${PRESCRICAO_EXAME_URL}/${exameId}`, exame)
    .then((resp: AxiosResponse<ExameView>) => resp.data)
}

/**
 * Inativa um exame cadastrado pelo médico
 * @param exameId Identificador do exame
 * @param data Dados atuais do exame (ExameDtoCadastro)
 * @returns ExameView
 */
export const inativarExame = (exameId: number, data: ExameDtoCadastro): Promise<ExameView> => {
  return updateExame(exameId, { ...data, ativo: false })
}

export const createExame = (
  atendimentoId: number,
  exames: PrescricaoDtoExame
): Promise<PrescricaoView[]> => {
  return axios
    .post(`${API_URL}/prescricao/exame/${atendimentoId}`, exames)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

export const deleteExame = (prescricaoId: number, exameId: number): Promise<void> => {
  return axios.delete(`${API_URL}/prescricao/exame/${prescricaoId}/${exameId}`)
}

// FORMULA
export const getFormulas = (query: string): Promise<FormulasQueryResponse> => {
  return axios
    .get(`${PRESCRICAO_FORMULA_URL}?${query}`)
    .then((resp: AxiosResponse<FormulasQueryResponse>) => resp.data)
}

export const getFormulaById = (formulaId: number): Promise<FormulaView> => {
  return axios
    .get(`${PRESCRICAO_FORMULA_URL}/${formulaId}`)
    .then((resp: AxiosResponse<FormulaView>) => resp.data)
}

/**
 * Altera uma fórmula
 * @param formulaId Identificador da fórmula
 * @param formula FormulaDtoCadastro
 * @returns FormulaView
 */
export const updateFormula = (
  formulaId: number,
  formula: FormulaDtoCadastro
): Promise<FormulaView> => {
  return axios
    .put(`${PRESCRICAO_FORMULA_URL}/${formulaId}`, formula)
    .then((resp: AxiosResponse<FormulaView>) => resp.data)
}

export const createFormula = (
  atendimentoId: number,
  formulas: PrescricaoDtoFormula
): Promise<PrescricaoView[]> => {
  return axios
    .post(`${API_URL}/prescricao/formula/${atendimentoId}`, formulas)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

export const deleteFormula = (prescricaoId: number, formulaId: number): Promise<void> => {
  return axios.delete(`${API_URL}/prescricao/formula/${prescricaoId}/${formulaId}`)
}

// ORIENTAÇÕES

/**
 * Busca orientações
 * @param query string
 * @returns OrientacoesQueryResponse
 */
export const getOrientacoes = (query: string): Promise<OrientacoesQueryResponse> => {
  return axios
    .get(`${PRESCRICAO_ORIENTACOES_URL}?${query}`)
    .then((resp: AxiosResponse<OrientacoesQueryResponse>) => resp.data)
}

/**
 * Busca uma orientação
 * @param orientacaoId Identificador de orientação
 * @returns OrientacaoView
 */
export const getOrientacaoById = (orientacaoId: number): Promise<OrientacaoView> => {
  return axios
    .get(`${PRESCRICAO_ORIENTACOES_URL}/${orientacaoId}`)
    .then((resp: AxiosResponse<OrientacaoView>) => resp.data)
}

/**
 * Altera uma prescrição de orientações
 * @param prescricaoId Identificador da prescrição
 * @param orientacoes PrescricaoDtoOrientacao
 * @returns PrescricaoView
 */
export const updateOrientacao = (
  prescricaoId: number,
  orientacoes: PrescricaoDtoOrientacao
): Promise<PrescricaoView> => {
  return axios
    .put(`${PRESCRICAO_ORIENTACAO_URL}/${prescricaoId}`, orientacoes)
    .then((resp: AxiosResponse<PrescricaoView>) => resp.data)
}

/**
 * Cria uma prescrição de orientações
 * @param atendimentoId Identificador do atendimento
 * @param orientacoes PrescricaoDtoOrientacao
 * @returns PrescricaoView
 */
export const createOrientacao = (
  atendimentoId: number,
  orientacoes: PrescricaoDtoOrientacao
): Promise<PrescricaoView[]> => {
  return axios
    .post(`${PRESCRICAO_ORIENTACAO_URL}/${atendimentoId}`, orientacoes)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

/**
 * Altera o status de uma orientação
 * @param orientacaoId Identificador da orientacao
 * @returns OrientacaoView
 */
export const inativarOrientacao = (orientacaoId: number): Promise<PrescricaoView[]> => {
  return axios
    .patch(`${PRESCRICAO_ORIENTACOES_URL}/${orientacaoId}?status=false`)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

/**
 * Exclui uma orientação da prescrição
 * @param prescricaoId Identificador da prescrição
 * @param orientacaoId Identificador da orientação
 * @returns void
 */
export const deleteOrientacao = (prescricaoId: number, orientacaoId: number): Promise<void> => {
  return axios.delete(`${PRESCRICAO_ORIENTACAO_URL}/${prescricaoId}/${orientacaoId}`)
}

// MEDICAMENTO
export const getMedicamentos = (query: string): Promise<MedicamentoQueryResponse> => {
  return axios
    .get(`${PRESCRICAO_MEDICAMENTO_URL}?${query}`)
    .then((resp: AxiosResponse<MedicamentoQueryResponse>) => resp.data)
}

export const getMedicamentoById = (medicamentoId: number): Promise<MedicamentoView> => {
  return axios
    .get(`${PRESCRICAO_MEDICAMENTO_URL}/${medicamentoId}`)
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Altera um medicamento
 * @param medicamentoId Identificador do medicamento
 * @param data MedicamentoDtoCadastro
 * @returns MedicamentoView
 */
export const updateMedicamento = (
  medicamentoId: number,
  data: MedicamentoDtoCadastro
): Promise<MedicamentoView> => {
  return axios
    .put(`${PRESCRICAO_MEDICAMENTO_URL}/${medicamentoId}`, data)
    .then((resp: AxiosResponse<MedicamentoView>) => resp.data)
}

/**
 * Inativa um medicamento cadastrado pelo médico
 * @param medicamentoId Identificador do medicamento
 * @param data Dados atuais do medicamento (MedicamentoDtoCadastro)
 * @returns MedicamentoView
 */
export const inativarMedicamento = (
  medicamentoId: number,
  data: MedicamentoDtoCadastro
): Promise<MedicamentoView> => {
  return updateMedicamento(medicamentoId, { ...data, ativo: false })
}

export const createMedicamento = (
  atendimentoId: number,
  medicamentos: PrescricaoDtoMedicamento
): Promise<PrescricaoView[]> => {
  return axios
    .post(`${API_URL}/prescricao/medicamento/${atendimentoId}`, medicamentos)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

export const deleteMedicamento = (prescricaoId: number, medicamentoId: number): Promise<void> => {
  return axios.delete(`${API_URL}/prescricao/medicamento/${prescricaoId}/${medicamentoId}`)
}

export const completePrescricao = (
  prescricao: PrescricaoDtoAssinatura
): Promise<PrescricaoView> => {
  return axios
    .post(`${API_URL}/prescricao/finaliza`, prescricao)
    .then((resp: AxiosResponse<PrescricaoView>) => resp.data)
}

/**
 * Gera formulário LME para prescrição (gera o PDF e assina)
 * @param prescricao PrescricaoDtoLmeQuantidade
 * @returns ArquivoDto
 */
export const updateGenerateLME = (prescricao: PrescricaoDtoLmeQuantidade): Promise<ArquivoDto> => {
  return axios
    .put(PRESCRICAO_LME_URL, prescricao)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Gera formulário APAC para prescrição (gera o PDF e assina)
 * @param prescricao PrescricaoDtoApacQuantidade
 * @returns ArquivoDto
 */
export const updateGenerateAPAC = (
  prescricao: PrescricaoDtoApacQuantidade
): Promise<ArquivoDto> => {
  return axios
    .put(PRESCRICAO_APAC_URL, prescricao)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Download de formulário LME da prescrição
 * @param prescricaoId Identificador da prescrição
 * @returns ArquivoDto
 */
export const downloadLME = (prescricaoId: number): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/prescricao/download/lme/${prescricaoId}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Download de formulário APAC da prescrição
 * @param prescricaoId Identificador da prescrição
 * @returns ArquivoDto
 */
export const downloadAPAC = (prescricaoId: number): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/prescricao/download/apac/${prescricaoId}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Download de documento gerado da prescrição
 * @param prescricaoId ID da prescrição
 * @param idDocumento ID do documento
 * @returns ArquivoDto
 */
export const downloadTermo = (prescricaoId: number, idDocumento: number): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/prescricao/download/documento/${prescricaoId}/${idDocumento}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Envia uma prescrição para o paciente
 * @param prescricaoId Identificador do paciente
 * @param dadosPaciente Objeto PrescricaoDtoDadosPaciente
 * @returns PrescricaoView
 */
export const sendPrescricao = (
  prescricaoId: number,
  dadosPaciente: PrescricaoDtoDadosPaciente
): Promise<PrescricaoView> => {
  return axios
    .post(`${API_URL}/prescricao/envia/${prescricaoId}`, dadosPaciente)
    .then((resp: AxiosResponse<PrescricaoView>) => resp.data)
}

export const getPrescriptionsByResponsavel = (query: string): Promise<PrescricoesQueryResponse> => {
  return axios
    .get(`${API_URL}/prescricao/responsavel?${query}`)
    .then((resp: AxiosResponse<PrescricoesQueryResponse>) => resp.data)
}

export const getPrescriptionsSigned = (query: string): Promise<PrescricoesQueryResponse> => {
  return axios
    .get(`${API_URL}/prescricao/responsavel/assinar?${query}`)
    .then((resp: AxiosResponse<PrescricoesQueryResponse>) => resp.data)
}

export const signPrescription = (receita: PrescricaoDtoAssinatura): Promise<ArquivoDto> => {
  return axios
    .patch(`${API_URL}/prescricao/responsavel/assinar`, receita)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

export const signPrescriptionLote = (
  receitas: PrescricaoDtoAssinaturaLote
): Promise<ArquivoDto> => {
  return axios
    .put(`${API_URL}/prescricao/responsavel/assinar`, receitas)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

export const downloadPrescription = (prescricaoId: number): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/prescricao/download/${prescricaoId}`)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}

/**
 * Busca tipos de atestado
 * @param query string
 * @returns TipoAtestadoQueryResponse
 */
export const getDocumentos = (query: string): Promise<TipoAtestadoQueryResponse> => {
  return axios
    .get(`${PRESCRICAO_ATESTADOS_URL}?${query}`)
    .then((resp: AxiosResponse<TipoAtestadoQueryResponse>) => resp.data)
}

/**
 * Busca um tipo de atestado
 * @param atestadoId Identificador do atestado
 * @returns TipoAtestadoView
 */
export const getDocumentoById = (atestadoId: number): Promise<TipoAtestadoView> => {
  return axios
    .get(`${PRESCRICAO_ATESTADOS_URL}/${atestadoId}`)
    .then((resp: AxiosResponse<TipoAtestadoView>) => resp.data)
}

/**
 * Cria atestado médico - Prescrição
 * @param atendimentoId Identificador do atendimento
 * @param atestado PrescricaoDtoAtestado
 * @returns PrescricaoView
 */
export const createAtestado = (
  atendimentoId: number,
  atestado: PrescricaoDtoAtestado
): Promise<PrescricaoView[]> => {
  return axios
    .post(`${PRESCRICAO_ATESTADO_URL}/${atendimentoId}`, atestado)
    .then((resp: AxiosResponse<PrescricaoView[]>) => resp.data)
}

/**
 * Altera um atestado médico - prescrição
 * @param prescricaoId Identificador da prescrição
 * @param atestado PrescricaoDtoAtestado
 * @returns PrescricaoView
 */
export const updateAtestado = (
  prescricaoId: number,
  atestado: PrescricaoDtoAtestado
): Promise<PrescricaoView> => {
  return axios
    .put(`${PRESCRICAO_ATESTADO_URL}/${prescricaoId}`, atestado)
    .then((resp: AxiosResponse<PrescricaoView>) => resp.data)
}

/**
 * Busca modelos de documentos
 * @param idPrescricao ID da prescrição
 * @param idCid ID do cid
 * @returns ModeloList[]
 */
export const getModelosOfDocumentos = (
  idPrescricao: number,
  idCid: number
): Promise<ModeloList[]> => {
  return axios
    .get(`${PRESCRICAO_DOCUMENTOS_URL}?idPrescricao=${idPrescricao}&idCid=${idCid}`)
    .then((resp: AxiosResponse<ModeloList[]>) => resp.data)
}

/**
 * Gera documento para prescrição (gera o PDF e assina)
 * @param data PrescricaoDtoDocumento
 * @returns ArquivoDto
 */
export const generateTermo = (data: PrescricaoDtoDocumento): Promise<ArquivoDto> => {
  return axios
    .post(`${PRESCRICAO_DOCUMENTO_URL}`, data)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}
